/**
 * useNewItems — suit l'apparition de nouvelles clés entre deux rendus.
 * Extrait de DpiLivePage (US-VDPI-06) pour réutilisation /vocal (Phase 1 A3, DRY).
 *
 * Retourne le set des clés présentes maintenant mais absentes au tick précédent
 * → utilisé pour déclencher l'animation slide-in/highlight. Le 1er rendu n'anime
 * rien (on n'anime pas le chargement initial).
 */

import { useEffect, useRef, useState } from 'react';

export function useNewItems(ids: string[]): Set<string> {
  const prevRef = useRef<Set<string> | null>(null);
  const [newSet, setNewSet] = useState<Set<string>>(new Set());

  useEffect(() => {
    const current = new Set(ids);
    const prev = prevRef.current;
    if (prev === null) {
      // 1er rendu : on mémorise sans animer.
      prevRef.current = current;
      return;
    }
    const added = ids.filter((id) => !prev.has(id));
    prevRef.current = current;
    if (added.length > 0) setNewSet(new Set(added));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids.join('|')]);

  return newSet;
}
